export const statusBarHeight: number = 90

export const vipColor: Record<number, string> = {
  1: '#EE946C',
  2: '#75A7FF',
  3: '#60E171',
  4: '#FF59BD',
  5: '#FFBC36'
}
